<template>

    <div @click="openSignupModal" class="d-inline-block">
        <slot></slot>
    </div>

</template>

<script>
export default {
    methods: {
        openSignupModal: function () {
            window.bus.$emit('openSignupModal');
        }
    },
}

</script>
